import type { JSX } from 'react';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/invoices/$id')({
  component: (): JSX.Element => <Outlet />,
});
